import { render, staticRenderFns } from "./scopeOfDistribution.vue?vue&type=template&id=7182547d&scoped=true"
import script from "./scopeOfDistribution.vue?vue&type=script&lang=js"
export * from "./scopeOfDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7182547d",
  null
  
)

export default component.exports